import { TableColumnDescription } from "./model/tableColumn.model";

export const form_columns_description: TableColumnDescription[] = [
  // Identification
  { name: 'name', class: 'table-constituent center', editable: true, initial: true },
  { name: 'formID', class: 'table-constituent center', editable: true, initial: true },
  { name: 'category', class: 'table-constituent center', editable: true, initial: true }
];